<div class="container-fluid d-flex flex-column h-100 p-1">
  <div class="flex-grow-1 overflow-auto">
    <ns-grid
      gridTitle="Additional Contacts"
      [columns]="columnDefs"
      [data]="data"
      [config]="config"
      [loading]="loading"
      [gridOptions]="options">
    </ns-grid>
  </div>
  <div *ngIf="isAdmin || canEdit" class="d-flex justify-content-end mb-3 mt-2">
    <button mat-flat-button color="accent" aria-label="Add NEw Contact Button" class="mr-2" (click)="openDialog()" [disabled]="!isProfile">Add New
      Contact
    </button>
  </div>
</div>
